import React from 'react';
import { useTranslate } from '@/locale';

interface DurationUnitProps {
  duration: string;
  unit: string;
}

const DurationUnit = ({ duration, unit }: DurationUnitProps) => {
  const { translate } = useTranslate();

  const computedUnit = duration === '1' ? unit.slice(0, -1) : unit;

  let translatedUnit;
  switch (computedUnit) {
    default:
      translatedUnit = computedUnit;
      break;
    case 'hours':
      translatedUnit = translate('durationUnitHours');
      break;
    case 'hour':
      translatedUnit = translate('durationUnitHour');
      break;
    case 'days':
      translatedUnit = translate('durationUnitDays');
      break;
    case 'day':
      translatedUnit = translate('durationUnitDay');
      break;
  }

  return (
    <span>
      {duration}
      &nbsp;
      {translatedUnit}
    </span>
  );
};

export { DurationUnit };
